import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'calculateOffsetWidth' })
export class CalculateOffsetWidthPipe implements PipeTransform {
  transform(limit: number, workingMinutes: number) {
    return limit / workingMinutes * 100 + '%';
  }
}
